import { CubeTextureLoader, TextureLoader } from "three";
import EventEmitter from "./EventEmitter";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader";
import { FontLoader } from "three/addons/loaders/FontLoader";
import { OBJLoader } from "three/addons/loaders/OBJLoader";

export default class Resources extends EventEmitter {
  constructor(sources) {
    super();

    this.sources = sources;

    // Set up
    this.items = {};
    this.toLoad = this.sources.length;
    this.loaded = 0;

    this.setLoaders();
    this.startLoading();
  }

  setLoaders() {
    this.loaders = {};
    this.loaders.fontLoader = new FontLoader();
    this.loaders.gltfLoader = new GLTFLoader();
    this.loaders.textureLoader = new TextureLoader();
    this.loaders.cubeTextureLoader = new CubeTextureLoader();
    this.loaders.objLoader = new OBJLoader();
  }

  startLoading() {
    for (const source of this.sources) {
      switch (source.type) {
        case "font":
          this.loaders.fontLoader.load(
            source.path,
            (font) => {
              this.sourceLoaded(source, font);
            },
            undefined,
            (error) => {
              console.error(error);
            }
          );
          break;
        case "gltf":
          this.loaders.gltfLoader.load(
            source.path,
            (gltf) => {
              this.sourceLoaded(source, gltf);
            },
            undefined,
            (error) => {
              console.error(error);
            }
          );
          break;
        case "texture":
          this.loaders.textureLoader.load(
            source.path,
            (file) => {
              this.sourceLoaded(source, file);
            },
            undefined,
            (error) => {
              console.error(error);
            }
          );
          break;
        case "cubeTexture":
          this.loaders.cubeTextureLoader.load(
            source.path,
            (texture) => {
              this.sourceLoaded(source, texture);
            },
            undefined,
            (error) => {
              console.error(error);
            }
          );
          break;
        case "img":
          const img = new Image();
          img.src = source.path;
          img.onload = () => {
            this.sourceLoaded(source, img);
          };
          break;
      }
    }
  }

  sourceLoaded(source, file) {
    this.items[source.name] = file;

    this.loaded++;

    this.loaded === this.toLoad
      ? this.trigger("ready")
      : this.trigger("progress");
  }
}
